'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};

var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _lodash = require('lodash');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactModal = require('react-modal');var _reactModal2 = _interopRequireDefault(_reactModal);
var _reactScroll = require('react-scroll');
var _get2 = require('lodash/get');var _get3 = _interopRequireDefault(_get2);
var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);
var _debounce = require('lodash/debounce');var _debounce2 = _interopRequireDefault(_debounce);
var _reactRouter = require('react-router');

var _Lightbox = require('../Lightbox/Lightbox');var _Lightbox2 = _interopRequireDefault(_Lightbox);
var _components = require('../../../components');















var _constants = require('../../../constants');








var _beautifyNumber = require('../../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _parkingConverter = require('../../../utils/parkingConverter');var _parkingConverter2 = _interopRequireDefault(_parkingConverter);
var _analyticsManager = require('../../../utils/analytics/analyticsManager');
var _remarketing = require('../../../utils/analytics/remarketing');
var _analyticsConstants = require('../../../utils/analytics/analyticsConstants');
var _adapter9 = require('./adapter');var _adapter10 = _interopRequireDefault(_adapter9);
var _summaryBuilder = require('./summaryBuilder');
var _scriptLoaders = require('../../../helpers/scriptLoaders');
var _buildVideoLinks2 = require('../../../utils/buildVideoLinks');var _buildVideoLinks3 = _interopRequireDefault(_buildVideoLinks2);

var _PropertyDetails = require('./PropertyDetails.scss');var styles = _interopRequireWildcard(_PropertyDetails);
var _appendLocale = require('../../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _PropertyDetailedForm = require('../../../containers/PropertyDetailedContactsUsForm/PropertyDetailedForm');var _PropertyDetailedForm2 = _interopRequireDefault(_PropertyDetailedForm);
var _images_placeholder = require('../../../../static/images/images_placeholder.svg');var _images_placeholder2 = _interopRequireDefault(_images_placeholder);
var _BasicInformation = require('../BasicInformation/BasicInformation');var _BasicInformation2 = _interopRequireDefault(_BasicInformation);
var _GalleryPreview = require('./GalleryPreview');var _GalleryPreview2 = _interopRequireDefault(_GalleryPreview);
var _SliderCart = require('../../ProjectDetailedInfo/SliderCart/SliderCart');var _SliderCart2 = _interopRequireDefault(_SliderCart);
var _modifyImageLink = require('../../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} /* eslint-disable jsx-a11y/media-has-caption */ // Modules
// Components
// Helpers
// Styles
var galleryViews = { PHOTOS: 'photos', VR: '3d',
  VIDEO: 'video' };


var tabId = {
  main: 'main',
  aboutProperty: 'aboutProperty',
  aboutBuilding: 'aboutBuilding',
  description: 'description',
  payments: 'payments',
  contactsForm: 'contactsForm' };


var PROPERTIES_COUNT_TO_SHOW = {
  MOBILE: 10,
  DESKTOP: 18 };var


PropertyDetails = function (_Component) {_inherits(PropertyDetails, _Component);
  function PropertyDetails(props) {_classCallCheck(this, PropertyDetails);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.




























    componentDidMount = function () {
      window.addEventListener('resize', _this.setPropertiesInRowCount);
      window.addEventListener('resize', _this.debouncedScroll);

      if (_this.props.isMobile && !_this.props.isPreview) {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }var

      propertyId = _this.props.propertyData.id;
      _this.updateDOMElementsData();

      if (propertyId || _this.props.isPreview) {
        _this.addScrollListener();

        propertyId && _this.sendRemarketingData(propertyId);
      }
      // observe for the element on scroll
      _this.contactObserver = new IntersectionObserver(
      function (_ref) {var entry = _ref[0];
        _this.setState({ isContactBlockVisible: entry.isIntersecting });
      },
      {
        root: null,
        threshold: 1.0 });



      // find element in BasicInformation component
      if (_this.contactButton) {
        _this.contactObserver.observe(_this.contactButton);
      }
    };_this.








































    componentWillUnmount = function () {
      if (_this.state.scrollElement) {
        _this.state.scrollElement.removeEventListener('scroll', _this.handleScroll);
      } else {
        window.removeEventListener('scroll', _this.handleScroll);
      }

      _this.props.changeLightboxActiveSlide(0);
      _this.props.resetDescriptionTranslate();
      window.removeEventListener('resize', _this.setPropertiesInRowCount);
      window.removeEventListener('resize', _this.debouncedScroll);
    };_this.

    setContactsWrapperRef = function (el) {
      _this.contactsWrapper = el;
    };_this.

    setContactsButtonRef = function (el) {
      _this.contactButton = el;
    };_this.

    setPropertyDetailsRef = function (el) {
      _this.propertyDetailsElement = el;
    };_this.

    setToolbarRef = function (el) {
      _this.toolbar = el;
    };_this.

    getOptionTitle = function (optionType) {
      switch (optionType) {
        case 'buy':return 'forSale';
        case 'rent':return 'forRent';
        case 'rent-short':return 'forShortRent';
        default:return '';}

    };_this.

    getPropertiesToShowCount = function () {
      if (_this.props.isMobile) {return PROPERTIES_COUNT_TO_SHOW.MOBILE;}
      if (!_this.container) {return PROPERTIES_COUNT_TO_SHOW.DESKTOP;}

      var rowsCount = 3;
      var countInRow = _this.getPropertiesInRowCount();

      return countInRow * rowsCount;
    };_this.

    getPropertiesInRowCount = function () {
      if (_this.props.isMobile) {return 1;}
      if (!_this.container) {return 3;}

      var containerWidth = _this.container.clientWidth;
      var propertyWidth = (0, _get3.default)(_this.container, 'children[0].children[0].clientWidth', 230);

      var scrollWidth = 15;
      var propertyMargin = 30;

      return Math.floor((containerWidth + scrollWidth) / (propertyWidth + propertyMargin));
    };_this.

    setPropertiesInRowCount = function () {
      var count = _this.getPropertiesInRowCount();

      if (count !== _this.state.propertiesInRowCount) {
        var propertiesToShowCount = _this.getPropertiesToShowCount();
        _this.setState({
          propertiesInRowCount: count,
          propertiesToShowCount: propertiesToShowCount });

      }
    };_this.

    sendRemarketingData = function (propertyId) {var _this$props =
      _this.props,isPreview = _this$props.isPreview,propertyData = _this$props.propertyData,translate = _this$props.translate,locale = _this$props.locale;
      if (isPreview) {
        return;
      }

      var description = _this.formatPropertyTitleForRemarketing(propertyData, translate);
      var englishAddressRequired = _constants.localesWithEnglishAddress.includes(locale);

      var city = (0, _get3.default)(propertyData, 'address[' + locale + '].city_name');
      var defaultLangCity = (0, _get3.default)(propertyData, 'address[' + _constants.language.default + '].city_name');

      var localisedCity = englishAddressRequired ?
      (0, _get3.default)(propertyData, 'address.en.city_name') :
      city || defaultLangCity;

      (0, _remarketing.sendFBRemarketingData)({
        id: propertyId,
        description: description,
        city: localisedCity,
        price: propertyData.price });


      (0, _scriptLoaders.googleRemarketingLoader)().then(function () {
        (0, _remarketing.sendGoogleRemarketingData)(propertyId, propertyData.price);
      });
    };_this.

    formatPropertyTitleForRemarketing = function (prop, translate) {
      if (!prop) {
        return null;
      }

      var rooms = prop.additional_info.rooms;
      var propertyType = prop.property_type;

      return propertyType + ' ' + translate('propertyDetails', 'SEOTitle', prop.search_option) + ' ' + rooms + ' ' + translate('propertyDetails', 'SEOTitle', 'rooms');
    };_this.

    showPrintPage = function () {return _this.setState({ printPageShown: true });};_this.

    hidePrintPage = function () {
      _this.setState({ printPageShown: !_this.state.printPageShown });
    };_this.

    updateDOMElementsData = function () {
      var headerElement = document.querySelector('header');
      var galleryElement = document.querySelector('.' + styles.galleryStyle);
      var appWrapper = document.scrollingElement || document.documentElement;
      var scrollElementForm = document.querySelector('[name="contactsForm"]');

      _this.setState({
        headerElement: headerElement,
        galleryElement: galleryElement,
        appWrapper: appWrapper,
        scrollElementForm: scrollElementForm });

    };_this.

    addScrollListener = function () {
      var scrollElement = document.querySelector('.ReactModal__Content');

      var targetElement = scrollElement || window;

      targetElement.addEventListener('scroll', _this.handleScroll);

      if (scrollElement) {
        _this.setState({ scrollElement: scrollElement });
      }
    };_this.

    resetFixedContacts = function () {
      if (!_this.contactsWrapper) return;

      _this.contactsWrapper.style.width = '';
      _this.contactsWrapper.style.top = '';
      _this.contactsWrapper.classList.remove(styles.contactsFixed);
      _this.contactsWrapper.parentElement.style.height = 'auto';
    };_this.

    handleScroll = function (evt) {return _this.props.isMobile ? _this.mobileHandleScroll(evt) : _this.desktopHandleScroll(evt);};_this.

    desktopHandleScroll = function () {var _adapter =
      (0, _adapter10.default)(_this.props),isActive = _adapter.isActive,isSuspended = _adapter.isSuspended;
      if (!isActive || isSuspended || !_this.contactsWrapper) {
        return;
      }var


      isModal =
      _this.props.isModal;var _this$state =





      _this.state,headerElement = _this$state.headerElement,scrollElement = _this$state.scrollElement,galleryElement = _this$state.galleryElement,appWrapper = _this$state.appWrapper;

      var headerOffset = headerElement && !isModal ? headerElement.offsetHeight - 1 : 0;
      var toolbarOffset = _this.toolbar ? _this.toolbar.offsetHeight : 0;
      var galleryOffset = galleryElement ? galleryElement.offsetHeight : 0;
      var contactsOffsetTop = toolbarOffset + headerOffset + galleryOffset;
      var offsetTop = scrollElement ? scrollElement.scrollTop : appWrapper.scrollTop;

      var isContactBlockAlreadySticky = _this.contactsWrapper.classList.contains(
      styles.contactsFixed);


      if (offsetTop >= contactsOffsetTop - headerOffset - toolbarOffset) {
        if (!isContactBlockAlreadySticky) {
          _this.contactsWrapper.style.top = headerOffset + toolbarOffset + 'px';
          _this.contactsWrapper.classList.add(styles.contactsFixed);
          _this.contactsWrapper.style.width =
          _this.contactsWrapper.parentElement.getBoundingClientRect().width + 'px';

          _this.contactsWrapper.parentElement.style.height = _this.contactsWrapper.offsetHeight + 'px';
        }
      } else if (isContactBlockAlreadySticky) {
        _this.resetFixedContacts();
      }
    };_this.

    scrollToForm = function () {var _this$state2 =



      _this.state,scrollElementForm = _this$state2.scrollElementForm,headerElement = _this$state2.headerElement;
      var scrollElementFormHeight = scrollElementForm ? scrollElementForm.offsetHeight : 0;
      var propertyDetailsHeight = _this.propertyDetailsElement ? _this.propertyDetailsElement.offsetHeight : 0;
      var headerHeight = headerElement ? headerElement.offsetHeight : 0;
      var toolbarHeight = _this.toolbar ? _this.toolbar.offsetHeight : 0;
      var contactsWrapperHeight = _this.contactsWrapper ? _this.contactsWrapper.offsetHeight : 0;

      if (_this.props.isModal) {
        var offset = propertyDetailsHeight - scrollElementFormHeight - contactsWrapperHeight - 32;

        _reactScroll.scroller.scrollTo('propertyDetails', {
          duration: 500,
          offset: offset,
          containerSelector: '.ReactModal__Content',
          smooth: true });

      } else {
        var _offset = -headerHeight - toolbarHeight - contactsWrapperHeight - 32;

        _reactScroll.scroller.scrollTo(tabId.contactsForm, {
          duration: 500,
          offset: _offset,
          smooth: true });

      }
    };_this.

    mobileHandleScroll = function () {};_this.

    createHelmet = function (id, thumbnail, images, sharingTitle, sharingUrl, description, isActive, isSuspended) {
      if (!id) {return null;}
      var protocol = sharingUrl.includes('://') ? '' : 'https://';

      var meta = [
      { name: 'description', content: description },
      { property: 'og:title', content: sharingTitle },
      { property: 'og:url', content: protocol + sharingUrl },
      { property: 'og:description', content: description },
      { name: 'viewport', content: 'width=device-width,user-scalable=no' }];


      if (images.length > 0) {
        var imageLink = (0, _get3.default)(images, '[0].gallery', '');
        meta = [].concat(
        meta, [
        { property: 'og:image', content: imageLink },
        { property: 'og:image:width', content: 800 },
        { property: 'og:image:height', content: 800 },
        { name: 'image', itemProp: 'image', content: thumbnail }]);

      }

      if (!isActive || isSuspended) {
        meta = [].concat(
        meta, [
        { name: 'robots', content: 'noindex' }]);

      }

      return _react2.default.createElement(_reactHelmet2.default, { meta: meta });
    };_this.

    navigateToProperty = function () {
      var navigate = confirm(_this.props.translate('propertyDetails', 'navigateToPropertyMessage')); // eslint-disable-line

      if (navigate) {var
        address = _this.props.propertyData.address;
        var url = 'waze://?ll=' + address.location.lat + ',' + address.location.lon + '&navigate=yes';
        window.open(url);
      }
    };_this.

    formatDate = function (dateString, translate) {
      if (!dateString) {
        return null;
      }

      var fullDay = 86400000; // 24 hours
      var date = (0, _moment2.default)(dateString);
      var today = (0, _moment2.default)().startOf('day');
      var yesterday = (0, _moment2.default)(today - fullDay);

      if (date.isSame(today, 'd')) {
        return translate('propertyDetails', 'today');
      } else if (date.isSame(yesterday, 'd')) {
        return translate('propertyDetails', 'yesterday');
      }

      return date.format('DD/MM/YYYY');
    };_this.

    checkIfResidenceForSale = function () {var _ref2 =
      _this.props.propertyData || {},section = _ref2.section,search_option = _ref2.search_option;
      return section === _constants.sections.homes.value && search_option === _constants.optionTypes.buy;
    };_this.

    switchGalleryView = function (evt) {
      evt.preventDefault();var
      target = evt.target;

      if ((0, _get3.default)(target, 'dataset.view') === galleryViews.PHOTOS) {
        _this.props.openLightbox(0);
      }

      while (!target.classList.contains(styles.galleryButtons)) {
        var galleryView = (0, _get3.default)(target, 'dataset.view');

        if (galleryView) {
          _this.setState({ galleryView: galleryView });
          return;
        }

        target = target.parentNode;
      }
    };_this.

    openMobileContactsModal = function () {
      _this.setState({ isModalOpen: true });
    };_this.

    closeMobileContactsModal = function () {
      _this.setState({ isModalOpen: false });
    };_this.

    renderColumn = function (array, idx, className) {return (
        _react2.default.createElement('div', { key: idx, className: className },
          array.map(function (_ref3) {var title = _ref3.title,value = _ref3.value;
            var parking = title === _this.props.translate('propertyDetails', 'details', 'parkingSpots');
            var hasParking = parking && value !== _this.props.translate('propertyDetails', 'none');
            var parkingData = (0, _get3.default)(_this.props, 'propertyData.additional_info.parking');
            var balconies = title === _this.props.translate('propertyDetails', 'details', 'balcony');
            var balconiesAreaData = (0, _get3.default)(_this.props, 'propertyData.additional_info.balconies_area');
            var hasBalconiesArea = balconies && balconiesAreaData;

            return (
              _react2.default.createElement('div', { key: title.toString(), className: styles.detailsColumnWrapper },
                _react2.default.createElement('p', { className: styles.singleDetail }, title),
                _react2.default.createElement('span', null, Array.isArray(value) ?
                  value.map(function (commodity) {return (
                      _react2.default.createElement('span', {
                          key: 'property-commodity-' + commodity,
                          className: styles.commodities },

                        _this.props.translate('propertyDetails', 'commodities', commodity)));}) : ' ' +


                  value),
                hasParking &&
                _react2.default.createElement(_components.ParkingTooltip, {
                  parking: parkingData,
                  locale: _this.props.locale,
                  translate: _this.props.translate }),

                hasBalconiesArea &&
                _react2.default.createElement(_components.BalconiesTooltip, {
                  balconies: balconiesAreaData,
                  translate: _this.props.translate })));



          })));};_this.



    renderShowAllButton = function () {return (
        _react2.default.createElement('p', { className: styles.showAllButton },
          _react2.default.createElement('i', { className: 'icon icon-arrow-down' }),
          _react2.default.createElement('span', null, _this.props.translate('showAll'))));};_this.



    renderHideShowAllButton = function () {return (
        _react2.default.createElement('p', { className: styles.hideAll },
          _react2.default.createElement('i', { className: 'icon icon-arrow-down' }),
          _react2.default.createElement('span', null, _this.props.translate('propertyDetails', 'hideDescription'))));};_this.



    renderDetails = function (detailsData, propertyCommodities) {
      var data = detailsData.map(function (detail) {
        if (_constants.alwaysDisplayedPropertyData.includes(detail.type)) {
          detail.value = detail.value || _this.props.translate('propertyDetails', 'none');
        }
        return detail;
      });

      var thirdColums = propertyCommodities && propertyCommodities.length ? [{
        title: _this.props.translate('propertyDetails', 'commodities', 'title'),
        value: propertyCommodities,
        type: 'commodities' }] :
      null;

      var notEmptyData = data.filter(function (_ref4) {var value = _ref4.value;return !!value;});
      var columnQuantity = 5;
      var firstColumn = notEmptyData.slice(0, columnQuantity);
      var secondColumn = notEmptyData.slice(columnQuantity);

      var result = [firstColumn];

      if (secondColumn.length) {result.push(secondColumn);}

      if (thirdColums) {result.push(thirdColums);}

      return result.map(function (array, idx) {return _this.renderColumn(array, idx, styles.propertyDetails);});
    };_this.

    renderBuildingDetails = function (detailsData) {return detailsData.map(function (_ref5) {var title = _ref5.title,value = _ref5.value;return value &&
        _react2.default.createElement('div', { key: title.toString(), className: styles.detailsColumnWrapper },
          _react2.default.createElement('p', { className: styles.singleDetail }, title),
          _react2.default.createElement('p', null, ' ' + value));});};_this.




    renderCallButton = function () {
      var phone = (0, _get3.default)(_this.props, 'propertyData.contacts.primary.phone', '');

      return _react2.default.createElement('a', { href: 'tel:' + phone, 'data-rel': 'external', className: styles.callButton },
        _react2.default.createElement('span', { className: (0, _classnames2.default)('icon icon-phone', styles.iconsIndent) }),
        _this.props.translate('propertyDetails', 'call'));


    };_this.

    renderLightbox = function (searchOptionType, propertyType, searchOption) {var _adapter2 =
      (0, _adapter10.default)(_this.props),id = _adapter2.id,address = _adapter2.address;
      var isForeign = address.en.country_name !== 'Israel';
      var images = (0, _get3.default)(_this.props, 'propertyData.images') || [];var _get =




      (0, _get3.default)(_this.props, 'propertyData'),currency = _get.currency,additional_info = _get.additional_info,price = _get.price;

      return (
        _react2.default.createElement(_Lightbox2.default, {
          isNative: _this.props.isNative,
          isModal: _this.props.isModal,
          isForeign: isForeign,
          id: id,
          propertyType: propertyType,
          searchOptionType: searchOptionType,
          searchOption: searchOption,
          propertyData: {
            currency: currency,
            additional_info: additional_info,
            price: price },

          isFavorite: _this.props.isFavorite,
          toggleFavorite: _this.props.toggleFavorite,
          currentImage: _this.props.currentImage || 0,
          changeLightboxActiveSlide: _this.props.isMobile ? _this.props.changeLightboxActiveSlide : null,
          images: images,
          videos: _this.renderVideo(),
          vrView: _this.renderVR(),
          isOpen: _this.props.isLightboxOpen,
          hideLightbox: _this.props.hideLightbox,
          translate: _this.props.translate('propertyDetails'),
          rootTranslate: _this.props.translate,
          locale: _this.props.locale,
          isMobile: _this.props.isMobile,
          isRtl: _this.props.isRtl,
          routeData: _this.props.routeData,
          additionalButton: _this.props.isMobile ? _this.renderCallButton() : null }));


    };_this.








































    renderOverlayLower = function () {return _react2.default.createElement('div', { className: styles.overlay });};_this.

    renderGalleryButton = function (type) {var _cx;return (
        _react2.default.createElement('button', {
            onClick: _this.switchGalleryView,
            'data-view': type,
            type: 'button',
            className: (0, _classnames2.default)((_cx = {}, _cx[styles.active] = _this.state.galleryView === type, _cx)) },

          _react2.default.createElement('span', { className: 'icon icon-gallery-' + type + '-preview' }),
          _this.props.translate('propertyDetails', 'gallery-' + type)));};_this.



    renderPayments = function () {
      var translate = _this.props.translate('propertyDetails');var _adapter3 =
      (0, _adapter10.default)(_this.props),searchOption = _adapter3.searchOption,isCottage = _adapter3.isCottage,payments = _adapter3.payments;

      return (
        _react2.default.createElement(_reactScroll.Element, { name: tabId.payments },
          _react2.default.createElement(_components.PropertyPaymentsBlock, {
            payments: payments,
            translate: translate,
            className: styles.propertyPaymentsWrapper,
            isCottageForSale: searchOption === 'buy' && isCottage,
            isRtl: _this.props.isRtl })));



    };_this.

    renderContactsForm = function () {var _adapter4 =
      (0, _adapter10.default)(_this.props),id = _adapter4.id,address = _adapter4.address;
      var isForeign = address.en.country_name !== 'Israel';

      return (
        _react2.default.createElement('div', { className: styles.row },
          _react2.default.createElement(_reactScroll.Element, { name: tabId.contactsForm },
            _react2.default.createElement(_PropertyDetailedForm2.default, {
              isModal: _this.props.isModal,
              entityId: id,
              isForeign: isForeign,
              entityType: 'property' }))));




    };_this.

    renderDescription = function () {
      var translate = _this.props.translate('propertyDetails');var _adapter5 =
      (0, _adapter10.default)(_this.props),desc = _adapter5.desc,descriptionData = _adapter5.descriptionData;

      return (
        _react2.default.createElement(_reactScroll.Element, { name: tabId.description, className: styles.row },
          _react2.default.createElement('span', { className: styles.title }, translate('description')),
          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.descriptionWrapper, styles.detailsText) },
            descriptionData.translatedDescriptionRequired &&
            _react2.default.createElement('div', { className: styles.translateDescriptionRow },
              _react2.default.createElement('button', {
                  className: styles.showOriginalDescription,
                  onClick: _this.props.toggleDescriptionTranslation },

                _react2.default.createElement('span', null,
                  translate('multilingualDescription', descriptionData.showOriginalDescription ?
                  'showOriginalDescription' :
                  'returnTranslation')), '\xA0',



                _react2.default.createElement('span', { className: styles.sub }, 'Powered by Google')), '\xA0\xA0'),





            _react2.default.createElement(_components.ShowMore, {
              text: desc,
              withoutEllipses: true,
              showHideButton: true,
              moreButtonText: _this.renderShowAllButton(),
              hideButtonText: _this.renderHideShowAllButton(),
              customStyles: styles.showMoreWrap,
              heightLimit: 124 }))));




    };_this.

    renderAboutBuilding = function () {
      var translate = _this.props.translate('propertyDetails');var _adapter6 =
      (0, _adapter10.default)(_this.props),aboutBuildingAdditionals = _adapter6.aboutBuildingAdditionals,aboutBuilding = _adapter6.aboutBuilding;

      var data = aboutBuilding && aboutBuilding.map(function (detail) {
        if (_constants.alwaysDisplayedPropertyData.includes(detail.type)) {
          detail.value = detail.value || _this.props.translate('propertyDetails', 'none');
        }
        return detail;
      });

      return (
        _react2.default.createElement(_reactScroll.Element, { name: tabId.aboutBuilding, className: styles.row },
          _react2.default.createElement('span', { className: styles.title }, translate('details', 'aboutBuilding')),
          _react2.default.createElement('div', { className: styles.buildingDetailsWrapper },
            _react2.default.createElement('div', { className: styles.detailsColumn },
              data && _this.renderBuildingDetails(data),
              aboutBuildingAdditionals.length > 0 &&
              _react2.default.createElement('div', { className: styles.commoditiesTitle },
                _react2.default.createElement('span', { className: styles.singleDetail }, translate('commodities', 'title')),
                _react2.default.createElement('div', { className: styles.detailsColumn },
                  aboutBuildingAdditionals.map(function (commodity) {return translate('commodities', commodity);}).join(', ')))))));







    };_this.

    renderAboutProperty = function () {
      var translate = _this.props.translate('propertyDetails');var _adapter7 =
      (0, _adapter10.default)(_this.props),aboutProperty = _adapter7.aboutProperty,aboutPropertyAdditionals = _adapter7.aboutPropertyAdditionals,searchOption = _adapter7.searchOption;

      var propertyCommodities = searchOption === 'buy' ?
      aboutPropertyAdditionals.filter(function (item) {return item !== 'roommates';}) :
      aboutPropertyAdditionals;

      return (
        _react2.default.createElement(_reactScroll.Element, { name: tabId.aboutProperty, className: styles.row },
          _react2.default.createElement('span', { className: styles.title }, translate('details', 'aboutProperty')),
          _react2.default.createElement('div', { className: styles.description },
            _react2.default.createElement('div', { className: styles.detailsColumn },
              _this.renderDetails(aboutProperty, propertyCommodities)))));




    };_this.

    renderGalleryButtons = function () {
      var hasVideos = !!(0, _get3.default)(_this.props, 'propertyData.videos[0]');
      var hasPhotos = !!(0, _get3.default)(_this.props, 'propertyData.images[0]');
      var hasVr = !!(0, _get3.default)(_this.props, 'propertyData.vr_link');

      return (
        _react2.default.createElement('div', { className: styles.galleryButtons },
          hasPhotos && _this.renderGalleryButton(galleryViews.PHOTOS),
          hasVr && _this.renderGalleryButton(galleryViews.VR),
          hasVideos && _this.renderGalleryButton(galleryViews.VIDEO)));


    };_this.

    renderHeader = function () {var _this$props2 =















      _this.props,isMobile = _this$props2.isMobile,isPreview = _this$props2.isPreview,locale = _this$props2.locale,isFavorite = _this$props2.isFavorite,toggleFavorite = _this$props2.toggleFavorite,routeData = _this$props2.routeData,preloadData = _this$props2.preloadData,propertyNote = _this$props2.propertyNote,isModal = _this$props2.isModal,handlePopupClose = _this$props2.handlePopupClose,propertyData = _this$props2.propertyData,userData = _this$props2.userData,handleEdit = _this$props2.handleEdit,isNative = _this$props2.isNative;var _adapter8 =

      (0, _adapter10.default)(_this.props),address = _adapter8.address,id = _adapter8.id,localisedAddress = _adapter8.localisedAddress,isActive = _adapter8.isActive,isSuspended = _adapter8.isSuspended;
      var isForeign = address.en.country_name !== 'Israel';
      var translate = _this.props.translate('propertyDetails');
      var isOverlay = !((isActive || isPreview) && !isSuspended);

      if (isMobile) {
        return (
          _react2.default.createElement(_components.PropertyToolsBarMobile, {
            locale: locale,
            isNative: isNative,
            translate: translate,
            rootTranslate: _this.props.translate,
            toggleFavorite: toggleFavorite,
            isFavorite: isFavorite,
            isMobile: isMobile,
            userData: userData,
            handleEdit: handleEdit,
            isPreview: isPreview,
            isForeign: isForeign,
            fetchPropertyNote: propertyNote,
            addPropertyNote: _this.props.addPropertyNote,
            hidePrintPage: _this.hidePrintPage,
            printPageShown: _this.state.printPageShown,
            id: id,
            routeData: routeData,
            preloadData: preloadData,
            propertyData: propertyData }));


      }

      return (
        _react2.default.createElement(_components.PropertyToolsBar, {
          toolbarRef: _this.setToolbarRef,
          isOverlay: isOverlay,
          localisedAddress: localisedAddress,
          locale: locale,
          translate: translate,
          rootTranslate: _this.props.translate,
          toggleFavorite: toggleFavorite,
          isFavorite: isFavorite,
          isMobile: isMobile,
          isPreview: isPreview,
          userData: userData,
          handleEdit: handleEdit,
          isForeign: isForeign,
          fetchPropertyNote: propertyNote,
          addPropertyNote: _this.props.addPropertyNote,
          hidePrintPage: _this.hidePrintPage,
          printPageShown: _this.state.printPageShown,
          id: id,
          routeData: routeData,
          handlePopupClose: handlePopupClose,
          preloadData: preloadData,
          isModal: isModal,
          propertyData: propertyData }));


    };_this.

    renderTab = function (item) {return (
        _react2.default.createElement(_reactScroll.Link, {
            className: styles.tab,
            'data-element': item.key,
            key: item.key,
            spy: true,
            activeClass: styles.activeTab,
            duration: 500,
            to: item.key,
            smooth: true,
            offset: -100 },

          _react2.default.createElement('span', null, _this.props.translate('ProjectDetails', 'tabList', item.key))));};_this.



    renderTabs = function (_ref6)




    {var isAboutBuildingFull = _ref6.isAboutBuildingFull,aboutBuildingAdditionals = _ref6.aboutBuildingAdditionals,description = _ref6.description,payments = _ref6.payments;
      var tabs = [
      {
        showTab: true,
        key: tabId.main },

      {
        showTab: true,
        key: tabId.aboutProperty },

      {
        showTab: !!isAboutBuildingFull || aboutBuildingAdditionals.length > 0,
        key: tabId.aboutBuilding },

      {
        showTab: !!description,
        key: tabId.description },

      {
        showTab: !!payments,
        key: tabId.payments },

      {
        showTab: true,
        key: tabId.contactsForm }].

      filter(function (value) {return value.showTab;});

      return (
        _react2.default.createElement('div', { className: styles.tabs },
          tabs.map(_this.renderTab)));


    };_this.

    renderPropertyCell = function (prop) {
      var englishAddressRequired = _constants.localesWithEnglishAddress.includes(_this.props.locale);
      var address = englishAddressRequired ?
      prop.address.en :
      prop.address[_this.props.locale] || prop.address[_constants.language.default];var


      id =











      prop.id,thumbnail = prop.thumbnail,price = prop.price,videos = prop.videos,property_type = prop.property_type,search_option = prop.search_option,_prop$additional_info = prop.additional_info;_prop$additional_info = _prop$additional_info === undefined ? {} : _prop$additional_info;var rooms = _prop$additional_info.rooms,parking = _prop$additional_info.parking,areaObject = _prop$additional_info.area,currency = prop.currency;

      var isLand = property_type === 'land'; // temp patch
      var floor = isLand ? undefined : (0, _get3.default)(prop, 'additional_info.floor.on_the');
      var roomsData = isLand ? undefined : rooms;

      var houseNumber = address.house_number ? ' ' + address.house_number + ',' : '';
      var addressString = address.street_name + ' ' + houseNumber;

      var propertyImage = thumbnail && (0, _modifyImageLink2.default)(thumbnail, _constants.imageModifierTypes.SLIDER_THUMBNAIL) || null;
      var propertyVideoPoster = videos && videos[0] && videos[0].id && (0, _buildVideoLinks3.default)(videos[0]).thumbnail;

      var area = (0, _lodash.isObject)(areaObject) ? areaObject.base : areaObject;

      var commonProps = {
        neighborhood: address.neighborhood,
        key: id,
        locale: _this.props.locale,
        isMobile: _this.props.isMobile,
        isRtl: _this.props.isRtl,
        translate: _this.props.translate,
        id: id,
        photo: propertyImage,
        videoPoster: propertyVideoPoster,
        price: price,
        address: addressString,
        rooms: roomsData,
        parkingSpots: parking,
        city: address.city_name,
        area: area,
        floor: floor,
        propertyType: _this.props.translate('propertyTypes', property_type)(),
        isPromoted: prop.is_promoted,
        hasVRLink: !!prop.vr_link,
        searchOption: search_option,
        groundFloorTitle: _this.props.translate('propertyDetails', 'details', 'groundFloorShortcut'),
        currency: currency,
        additionalClassName: prop.additionalClassName };


      var style = {};
      var route = (0, _appendLocale2.default)(
      _this.props.locale, '/home_details/' +
      id);

      var openDetailsPopup = function openDetailsPopup() {return window.open(route);};
      if (!_this.props.isMobile) {
        style.width = 'calc((100% / ' + _this.state.propertiesInRowCount + ') - 30px)';
      }

      return _this.props.isMobile ?

      _react2.default.createElement(_components.PropertyCell, _extends({},
      commonProps, {
        openDetailsPopup: openDetailsPopup })) :



      _react2.default.createElement('div', { key: id, 'data-id': id, onClick: openDetailsPopup, style: style },
        _react2.default.createElement(_components.OMBaseVerticalPropertyCell, _extends({},
        commonProps, {
          isHomePageSlider: true })));



    };_this.

    renderPropertiesByOwnerBlock = function () {var _this$props3 =
      _this.props,isMobile = _this$props3.isMobile,propertiesByOwner = _this$props3.propertyData.properties_by_owner;

      if (!propertiesByOwner || !propertiesByOwner.length) {return null;}

      return (
        _react2.default.createElement('div', { className: styles.similarWrapper },
          _react2.default.createElement(_SliderCart2.default, {
              isShowNavigation: propertiesByOwner.length >= 3 || isMobile,
              title: _this.props.translate('propertyDetails', 'propertiesByOwner') },

            propertiesByOwner.map(function (prop) {return _this.renderPropertyCell(Object.assign({},
              prop, {
                additionalClassName: 'similarProperty' }));}))));




    };_this.

    renderSimilarBlock = function () {var _this$props4 =
      _this.props,isMobile = _this$props4.isMobile,similarProperties = _this$props4.similarProperties;

      if (!similarProperties || !similarProperties.length) {return null;}

      return (
        _react2.default.createElement('div', { className: styles.similarWrapper },
          _react2.default.createElement(_SliderCart2.default, {
              isShowNavigation: similarProperties.length >= 3 || isMobile,
              title: _this.props.translate('propertyDetails', 'similarProperty') },

            similarProperties.map(function (prop) {return _this.renderPropertyCell(Object.assign({},
              prop, {
                additionalClassName: 'similarProperty' }));}))));




    };_this.

    renderVR = function () {return _this.state.galleryView === galleryViews.VR &&
      _react2.default.createElement('iframe', {
        title: 'galleryVr',
        width: _this.props.screenWidth || '100%',
        height: _this.props.isMobile ? 344 : '100%',
        src: _this.props.propertyData.vr_link,
        frameBorder: '0',
        allowFullScreen: true,
        allow: 'vr' });};_this.



    renderVideo = function () {
      if (_this.state.galleryView !== galleryViews.VIDEO) {return null;}

      var video = (0, _get3.default)(_this.props, 'propertyData.videos[0]');

      if (!video) {return null;}var _buildVideoLinks =

      (0, _buildVideoLinks3.default)(video),thumbnail = _buildVideoLinks.thumbnail,full = _buildVideoLinks.full;
      return (
        _react2.default.createElement('video', {
            controls: true,
            poster: thumbnail,
            width: _this.props.isMobile ? _this.props.screenWidth : 915,
            height: _this.props.isMobile ? 281 : 550 },

          _react2.default.createElement('source', { src: full + '.mp4', type: 'video/mp4' }),
          _react2.default.createElement('source', { src: full + '.ogv', type: 'video/ogv' }),
          _react2.default.createElement('source', { src: full + '.webm', type: 'video/webm' })));


    };_this.













































































    renderPropertySummaryTitle = function (formattedData) {var _buildPropertySummary =
      (0, _summaryBuilder.buildPropertySummaryTitle)(formattedData),propertyType = _buildPropertySummary.propertyType,fullAddress = _buildPropertySummary.fullAddress;
      var additionalInfo = _this.props.translate('propertyDetails', 'additionalInfo');
      var at = _this.props.translate('propertyDetails', 'at');
      var separator = _this.props.locale === _constants.language.default ? '' : ' ';
      return additionalInfo + ' ' + propertyType + ' ' + at + separator + fullAddress;
    };_this.state = { headerElement: _this.props.isMobile ? { offsetHeight: 50 } : null, galleryElement: null, scrollElement: null, scrollElementForm: null, appWrapper: null, propertiesInRowCount: props.isMobile ? 1 : 6, printPageShown: false, mortgageIsOpen: false, galleryView: galleryViews.PHOTOS, isModalOpen: false, isContactBlockVisible: true };_this.contactButton = null;_this.propertyDetailsElement = null;_this.contactsWrapper = null;_this.toolbar = null;_this.contactObserver = null;_this.debouncedScroll = (0, _debounce2.default)(_this.handleScroll, 250);return _this;}PropertyDetails.prototype.componentWillMount = function componentWillMount() {this.props.detectDescriptionLanguage({ q: this.props.propertyData.description, locale: this.props.locale });};PropertyDetails.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref7) {var isMobile = _ref7.isMobile,isLightboxOpen = _ref7.isLightboxOpen,descriptionData = _ref7.descriptionData;if (isMobile && isLightboxOpen !== this.props.isLightboxOpen) {this.container.style.position = isLightboxOpen ? 'fixed' : 'relative';}if (isMobile && this.contactsWrapper && this.contactsWrapper.classList.contains(styles.contactsFixed)) {this.resetFixedContacts();}if (descriptionData.showOriginalDescription && !descriptionData.descriptionLoading && !descriptionData.descriptionLoaded) {this.props.translateDescription({ q: this.props.propertyData.description });}};PropertyDetails.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {var prevId = prevProps.propertyData ? prevProps.propertyData.id : null;var currentId = this.props.propertyData.id;var prevDescription = prevProps.propertyData ? prevProps.propertyData.description : null;var currentDescription = this.props.propertyData ? this.props.propertyData.description : null;if (!!currentDescription && prevDescription !== currentDescription) {this.props.detectDescriptionLanguage({ q: currentDescription, locale: this.props.locale });}if (!prevId && currentId && !prevState.scrollElement) {this.updateDOMElementsData();this.addScrollListener();this.sendRemarketingData(currentId);}};PropertyDetails.prototype.renderDate = function renderDate() {var _this2 = this,_cx2;var _props$propertyData = this.props.propertyData,createdAt = _props$propertyData.created_at,lastUserUpdateDate = _props$propertyData.last_user_update_date;var publishDate = this.formatDate(createdAt, this.props.translate);var updateDate = this.formatDate(lastUserUpdateDate || createdAt, this.props.translate);var rowRender = function rowRender(name, date, brackets) {return _react2.default.createElement('span', null, brackets ? '(' : null, _react2.default.createElement('span', { className: styles.label }, _this2.props.translate('propertyDetails', 'details', name)), ':\xA0', date, brackets ? ')' : null);};return _react2.default.createElement('p', { className: (0, _classnames2.default)(styles.date, (_cx2 = {}, _cx2[styles.mobile] = this.props.isMobile, _cx2)) }, rowRender('publishDate', publishDate), '\xA0\xA0', updateDate && rowRender('updateDate', updateDate, true));};PropertyDetails.prototype.renderOverlayUpper = function renderOverlayUpper() {return _react2.default.createElement('div', { className: styles.overlay }, _react2.default.createElement('div', { className: styles.inactiveMessage }, _react2.default.createElement('div', null, this.props.translate('propertyDetails', 'details', 'inactiveProperty')), _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(this.props.locale, '/homes/buy') }, this.props.translate('propertyDetails', 'details', 'backToSearch'))));};PropertyDetails.prototype.renderGallery = function renderGallery() {var _this3 = this;var _props = this.props,openLightbox = _props.openLightbox,isMobile = _props.isMobile,translate = _props.translate,isLightboxOpen = _props.isLightboxOpen;var videoTour = (0, _get3.default)(this.props, 'propertyData.videos[0]');var hasVideoTour = !!videoTour;var hasVr = !!(0, _get3.default)(this.props, 'propertyData.vr_link');var images = (0, _get3.default)(this.props, 'propertyData.images', []);var imagesLength = images.length;var list = images.slice(0, 5);var openVideo = function openVideo(event) {event.stopPropagation();_this3.setState({ galleryView: galleryViews.VIDEO });openLightbox();};var handleClick = function handleClick(event) {event.stopPropagation();_this3.setState({ galleryView: (0, _get3.default)(event, 'target.dataset.type') });openLightbox();};switch (true) {case isMobile && (!(0, _isEmpty2.default)(list) || !(0, _isEmpty2.default)(videoTour)):return _react2.default.createElement(_components.MobileInlineGallery, { currentImage: this.props.currentImage, images: images, videos: videoTour, openLightbox: openLightbox, isLightboxOpen: isLightboxOpen, isRtl: this.props.isRtl, switchGalleryView: this.switchGalleryView });case !isMobile && (!(0, _isEmpty2.default)(list) || !(0, _isEmpty2.default)(videoTour)):return _react2.default.createElement(_GalleryPreview2.default, { images: list, videoTour: videoTour, openVideo: openVideo, isMobile: this.props.isMobile, screenWidth: this.props.screenWidth, openLightbox: openLightbox }, _react2.default.createElement('div', { className: styles.seeAllWrapper }, images.length > 1 && _react2.default.createElement('p', { 'data-type': galleryViews.PHOTOS, onClick: handleClick }, _react2.default.createElement('span', { className: (0, _classnames2.default)('icon icon-gallery-photos-preview', styles.iconsIndent) }), translate('propertyDetails', 'see') + ' ' + imagesLength + ' ' + translate('propertyDetails', 'gallery-photos')), hasVideoTour && _react2.default.createElement('p', { 'data-type': galleryViews.VIDEO, onClick: handleClick }, _react2.default.createElement('span', { className: (0, _classnames2.default)('icon icon-gallery-video-preview', styles.iconsIndent) }), translate('propertyDetails', 'gallery-video')), hasVr && _react2.default.createElement('p', { 'data-type': galleryViews.VR, onClick: handleClick }, _react2.default.createElement('span', { className: (0, _classnames2.default)('icon icon-gallery-3d-preview', styles.iconsIndent) }), translate('propertyDetails', 'gallery-3d'))));default:return _react2.default.createElement('img', { alt: '', src: _images_placeholder2.default });}};PropertyDetails.prototype.
  render = function render() {var _cx3,_this4 = this,_cx4;
    if (!this.props.locale || !this.props.propertyData || !this.props.propertyData.address) return null;var _props2 =






    this.props,isMobile = _props2.isMobile,isPreview = _props2.isPreview,isRtl = _props2.isRtl,locale = _props2.locale,isNative = _props2.isNative;
    var translate = this.props.translate('propertyDetails');

    var formattedData = (0, _adapter10.default)(this.props);var


    address =






























    formattedData.address,hasPhotos = formattedData.hasPhotos,contactsData = formattedData.contactsData,price = formattedData.price,currency = formattedData.currency,pricePerSqMeter = formattedData.pricePerSqMeter,contacts = formattedData.contacts,companyContacts = formattedData.companyContacts,realtorProperty = formattedData.realtorProperty,type = formattedData.type,searchOption = formattedData.searchOption,localisedAddress = formattedData.localisedAddress,isGroundFloor = formattedData.isGroundFloor,floorOn = formattedData.floorOn,payments = formattedData.payments,isSuspended = formattedData.isSuspended,aboutBuildingAdditionals = formattedData.aboutBuildingAdditionals,isAboutBuildingFull = formattedData.isAboutBuildingFull,parking = formattedData.parking,rooms = formattedData.rooms,areaValue = formattedData.areaValue,isActive = formattedData.isActive,description = formattedData.description,id = formattedData.id,agencyId = formattedData.agencyId,images = formattedData.images,thumbnail = formattedData.thumbnail,sharingTitle = formattedData.sharingTitle,sharingUrl = formattedData.sharingUrl,SEODescription = formattedData.SEODescription,isLand = formattedData.isLand;

    var isForeign = address.en.country_name !== 'Israel';
    var hasVideos = !!(0, _get3.default)(this.props, 'propertyData.videos.length');
    var staticMapboxImage = (0, _get3.default)(this.props, 'propertyData.static_mapbox_image', {});
    var isTopPromoted = (0, _get3.default)(this.props, 'propertyData.is_top_promoted');
    var isRealtorProperty = (0, _get3.default)(this.props, 'propertyData.realtor_property');
    var shouldRemovePropertyRealtorIcon = (0, _get3.default)(this.props, 'propertyData.should_remove_property_realtor_icon');
    var helmet = this.createHelmet(id, thumbnail || '', images, sharingTitle, sharingUrl, SEODescription, isActive, isSuspended);
    var floorValue = isGroundFloor ? translate('details', 'groundFloorShortcut') : floorOn;
    var searchOptionType = this.getOptionTitle(searchOption);
    var shouldRenderPricePerSqMeter = this.checkIfResidenceForSale();
    var showAddress =
    !!localisedAddress.city_name ||
    !!localisedAddress.neighborhood ||
    !!localisedAddress.street_name ||
    !!localisedAddress.country_name;

    return (
      _react2.default.createElement('div', {
          vocab: 'http://schema.org/',
          'typeof': 'Apartment',
          className: (0, _classnames2.default)(
          styles.contentWrapper,
          this.props.className, (_cx3 = {}, _cx3[

          styles.native] = this.props.isNative, _cx3[
          styles.foreignContent] = isForeign, _cx3)),


          id: 'containerElement',
          ref: function ref(container) {_this4.container = container;} },

        _react2.default.createElement('div', { className: styles.upper },
          helmet,
          this.renderHeader(),
          (isActive || isPreview) && !isSuspended ? null : this.renderOverlayUpper(),
          _react2.default.createElement(_reactScroll.Element, { name: tabId.main, className: (0, _classnames2.default)(styles.galleryStyle, (_cx4 = {}, _cx4[styles.streetView] = !hasPhotos, _cx4)) },
            this.state.galleryView === galleryViews.PHOTOS &&
            _react2.default.createElement('div', { className: styles.promotionWrapper },
              isTopPromoted && _react2.default.createElement('div', { className: styles.top }, 'TOP'),
              !isRealtorProperty ?
              _react2.default.createElement('div', null, translate('regularAdvert')) :
              null,


              isRealtorProperty && !shouldRemovePropertyRealtorIcon ?
              _react2.default.createElement('div', null, translate('realtorAdvert')) :
              null),



            !this.props.isMobile ?
            this.renderGallery() :
            this.state.galleryView === galleryViews.PHOTOS && this.renderGallery(),
            this.props.isMobile && this.state.galleryView === galleryViews.VR && this.renderVR(),
            this.props.isMobile && this.state.galleryView === galleryViews.VIDEO && this.renderVideo()),


          this.props.isMobile &&
          _react2.default.createElement('div', { className: styles.galleryButtonsWrapper },
            this.renderGalleryButtons()),


          _react2.default.createElement(_BasicInformation2.default, {
            contactButtonRef: this.setContactsButtonRef,
            stickyContainerRef: this.setContactsWrapperRef,
            isNative: isNative,
            isMobile: isMobile,
            isForeign: isForeign,
            localisedAddress: localisedAddress,
            price: (0, _beautifyNumber2.default)(price),
            isRtl: this.props.isRtl,
            searchOption: searchOptionType,
            translate: translate,
            currency: currency,
            propertyType: type,
            searchOptionType: translate(searchOptionType),
            pricePerSqMeter: shouldRenderPricePerSqMeter ? (0, _beautifyNumber2.default)(pricePerSqMeter) : null,
            additionalInfo: {
              floor: isLand ? undefined : floorValue,
              parkingSpots: (0, _parkingConverter2.default)(parking),
              area: areaValue,
              rooms: isLand ? undefined : rooms },

            contactsData: {
              locale: locale,
              translate: this.props.translate,
              contacts: contacts,
              data: contactsData,
              isPreview: isPreview,
              isCompanyActive: this.props.propertyData.is_company_active,
              realEstateData: {
                isAgent: realtorProperty,
                agencyId: agencyId,
                companyName: companyContacts.name,
                logo: companyContacts.logo },

              shouldRemovePropertyRealtorIcon: shouldRemovePropertyRealtorIcon,
              incrementClicks: this.props.incrementClicks,
              showPrintPage: this.showPrintPage,
              scrollToForm: this.scrollToForm },

            openMobileContactsModal: this.openMobileContactsModal,
            closeMobileContactsModal: this.closeMobileContactsModal,
            isModalOpen: this.state.isModalOpen,
            isContactBlockVisible: this.state.isContactBlockVisible }),

          _react2.default.createElement('div', { ref: this.setPropertyDetailsRef, id: 'propertyDetails', className: styles.content },
            showAddress && !isMobile &&
            _react2.default.createElement('div', { className: styles.addressWrapper },
              _react2.default.createElement('div', { className: styles.addressLine },
                !!localisedAddress.street_name &&
                _react2.default.createElement('p', { className: styles.streetName },
                  localisedAddress.street_name, '\xA0',
                  localisedAddress.house_number,

                  (!localisedAddress.neighborhood ||
                  localisedAddress.neighborhood === localisedAddress.city_name) &&
                  ',', '\xA0'),




                localisedAddress.neighborhood &&
                localisedAddress.neighborhood !== localisedAddress.city_name &&
                _react2.default.createElement('div', null,
                  localisedAddress.neighborhood, ', \xA0'),



                _react2.default.createElement('div', null, localisedAddress.city_name, isForeign && '' + (localisedAddress.city_name ? ', ' : '') + localisedAddress.country_name))),



            _react2.default.createElement('div', { className: styles.details },
              isMobile && this.renderTabs({
                isAboutBuildingFull: isAboutBuildingFull,
                aboutBuildingAdditionals: aboutBuildingAdditionals,
                description: description,
                payments: payments }),

              this.renderAboutProperty(),
              (isAboutBuildingFull || aboutBuildingAdditionals.length > 0) && this.renderAboutBuilding(),
              description && this.renderDescription(),
              payments && this.renderPayments(),
              this.renderContactsForm())),


          _react2.default.createElement('div', { className: styles.map },
            _react2.default.createElement(_components.PropertyMap, {
              translate: translate('mapContainer'),
              staticMapboxImage: staticMapboxImage,
              location: address.location || { lat: 0, lon: 0 },
              locale: locale,
              isMobile: isMobile,
              isModal: this.props.isModal }))),



        _react2.default.createElement('div', { className: styles.unblurred },
          this.props.propertyData && realtorProperty && this.renderPropertiesByOwnerBlock(),
          this.props.similarProperties && this.renderSimilarBlock()),

        _react2.default.createElement('div', { className: styles.lower },
          searchOption === 'buy' && !isForeign ?
          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.row, styles.mortgageCalculatorContainer) },
            _react2.default.createElement('span', { className: styles.title }, translate('mortgageCalculate', 'title')),
            _react2.default.createElement(_components.OMAccordion, {
                titleValue:
                _react2.default.createElement('span', null,
                  translate('mortgageCalculate', this.state.mortgageIsOpen ? 'close' : 'open')),


                className: styles.calculatorWrapper,
                onOpen: function onOpen() {
                  (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.propertyDetails, _analyticsConstants.eventAction.click, _analyticsConstants.eventLabel.openMortgageCalculator);
                  _this4.setState({ mortgageIsOpen: true });
                },
                onClose: function onClose() {
                  _this4.setState({ mortgageIsOpen: false });
                } },

              _react2.default.createElement(_components.MortgageCalculate, {
                translate: translate('mortgageCalculate'),
                price: price,
                isMobile: isMobile,
                isRtl: isRtl }))) :



          null,

          (hasPhotos || hasVideos) && this.renderLightbox(searchOptionType, type, translate(searchOptionType)),

          !isPreview &&
          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.metaInfo) },
            this.renderDate(),

            _react2.default.createElement('div', { className: styles.propertySummary },
              _react2.default.createElement('span', { className: styles.summaryTitle }, this.renderPropertySummaryTitle(formattedData)),

              _react2.default.createElement('br', null),

              (0, _summaryBuilder.buildPropertySummary)(formattedData, this.props.translate))),




          (isActive || isPreview) && !isSuspended ? null : this.renderOverlayLower(),

          _react2.default.createElement(_reactModal2.default, {
              isOpen: this.state.printPageShown,
              contentLabel: 'PropertyDetailsPrintPage',
              portalClassName: 'print-page',
              style: _constants.cleanModalStyle },

            _react2.default.createElement(_components.PropertyDetailsPrintPage, {
              isRtl: isRtl,
              data: formattedData,
              locale: locale,
              translate: this.props.translate,
              propertyType: this.props.propertyData.property_type,
              hidePrintPage: this.hidePrintPage,
              enPropertyType: this.props.enPropertyType })))));





  };return PropertyDetails;}(_react.Component);


PropertyDetails.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  propertyData: _propTypes2.default.object,
  isModal: _propTypes2.default.bool,
  openLightbox: _propTypes2.default.func,
  hideLightbox: _propTypes2.default.func,
  changeLightboxActiveSlide: _propTypes2.default.func,
  isLightboxOpen: _propTypes2.default.bool,
  currentImage: _propTypes2.default.number,
  className: _propTypes2.default.string,
  openModalContacts: _propTypes2.default.func,
  hideModalContacts: _propTypes2.default.func,
  openModalShare: _propTypes2.default.func,
  hideModalShare: _propTypes2.default.func,
  isModalShareOpen: _propTypes2.default.bool,
  isModalContactsOpen: _propTypes2.default.bool,
  screenWidth: _propTypes2.default.number,
  isPublish: _propTypes2.default.bool,
  isPreview: _propTypes2.default.bool,
  isFavorite: _propTypes2.default.bool,
  toggleFavorite: _propTypes2.default.func,
  addPropertyNote: _propTypes2.default.func,
  propertyNote: _propTypes2.default.string,
  isNative: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  enPropertyType: _propTypes2.default.string,
  userData: _propTypes2.default.object,
  handleEdit: _propTypes2.default.func,
  translateDescription: _propTypes2.default.func,
  toggleDescriptionTranslation: _propTypes2.default.func,
  descriptionData: _propTypes2.default.object,
  routeData: _propTypes2.default.object,
  preloadData: _propTypes2.default.object,
  detectDescriptionLanguage: _propTypes2.default.func,
  resetDescriptionTranslate: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  incrementClicks: _propTypes2.default.func,
  hidePrintPage: _propTypes2.default.func,
  handlePopupClose: _propTypes2.default.func,
  similarProperties: _propTypes2.default.object,
  printPageShown: _propTypes2.default.bool };exports.default =


PropertyDetails;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/PropertyDetails/PropertyDetails.js
// module id = 2852
// module chunks = 0